import {
   Button,
   Box,
   TableContainer,
   Table,
   Thead,
   Tr,
   Th,
   Tbody,
   Td,
   IconButton,
   Flex,
   FormControl,
   Input,
   Tfoot,
   useColorModeValue,
} from '@chakra-ui/react';
import React, { useState, useEffect, useCallback } from 'react';

// import { renderDynamicDropdown } from 'components/ui/DynamicDropdown';
import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
import InputField from 'components/ui/InputField';

import { getColumnHeaders } from 'utils/saleUtility';
import { formatAmount, isElementDisabled, forceDisabledCheck } from 'utils/util';
import { SupplyTypes } from 'utils/dropdownEnum';

import { getUnit } from '../../../../../redux/actions/uqc';
import { getGrayPurchasePendingIssue } from '../../../../../redux/actions/purchaseInvoice';
import { getPendingReceiveInventories } from '../../../../../redux/actions/receiveInventory';

// Icons
import { FaPlus, FaTrash } from 'react-icons/fa';
import { getItem } from '../../../../../redux/actions/item';
import { useGlobal, useBusinessType, useUser } from 'contexts';
import { useSelector, useDispatch } from 'react-redux';

const LineItem = ({
   addLineItem,
   lineItems,
   itemData,
   textColor,
   lastDaybook,
   removeLineItem,
   handleOnChange,
   companyData,
   totals,
   errors,
   handleStockModalOnClick,
   refs,
   prerefs,
   setCurrentLineItemIdx,
   type,
   warehouseList,
   lineitemview,
   selectcompany,
   lineDetailview,
   billTermData,
}) => {
   const dispatch = useDispatch();
   const [activeRow, setActiveRow] = useState(null);
   // const [activeHeader, setActiveHeader] = useState(null);
   const [companySetting, setCompanySetting] = useState({});
   const uqcData = useSelector((state) => state.uqc?.list);
   const [isGSTApply, setIsGSTApply] = useState(false);
   const [tempItemId, SetTempItemId] = useState('');
   const [tempIndex, SetTempIndex] = useState('');
   const { businessTypes } = useBusinessType();
   const { userGlobalSettingsData } = useGlobal();
   const { user } = useUser();
   const headers = getColumnHeaders(activeRow, lineItems, itemData);
   const { company } = useGlobal();
   const purchase = useSelector((state) => state.purchaseInvoice.grayPurchasePendingIssue ?? []);
   const pendingReceive = useSelector((state) => state.receiveInventory.getPendingReceiveInventories ?? []);
   const shouldSendCompanyIdItem = userGlobalSettingsData?.[0]?.askCompany?.item || false;

   useEffect(() => {
      if (uqcData.length <= 0) {
         dispatch(getUnit());
      }
      dispatch(
         getItem({
            companyId: user?.loginhistory.companyId,
            sortBy: 'name',
            sortOrder: 'asc',
            ...(shouldSendCompanyIdItem && { companyIds: user?.loginhistory?.companyId }),
         }),
      );
   }, [dispatch, shouldSendCompanyIdItem, uqcData.length, user?.loginhistory.companyId]);

   const handleFocus = (rowIndex, columnIndex, headerText) => {
      setActiveRow(rowIndex);
      // setActiveHeader(columnIndex);
      // setActiveHeaderText(headerText);
   };

   const handleModalOpen = (value, index) => {
      setTimeout(() => {
         const selectedItem = itemData?.find((item) => item.id.toString() === value?.toString());
         if (selectedItem?.itemdetailtype === 1) {
            handleStockModalOnClick(index);
         }
      }, 500);
      SetTempItemId(value);
      SetTempIndex(index);
   };

   useEffect(() => {
      const selectedItem = itemData?.find((item) => item.id.toString() === tempItemId?.toString());
      if (selectedItem?.itemdetailtype === 1) {
         if (type === 'recive') {
            handleStockModalOnClick(tempIndex, 'recive');
         } else if (type === 'purchase') {
            handleStockModalOnClick(tempIndex, 'purchaseinvoice');
         }
      }
      SetTempIndex('');
      SetTempItemId('');
   }, [itemData, tempItemId, tempIndex]);

   useEffect(() => {
      setCompanySetting(company?.setting);
   }, [company?.setting]);

   useEffect(() => {
      if (lastDaybook?.applyGst && companySetting?.applyGST) {
         setIsGSTApply(true);
      }
   }, [companySetting?.applyGST, lastDaybook?.applyGst]);
   const headerbg = useColorModeValue('gray.200', '#262b33');

   useEffect(() => {
      if (
         businessTypes?.businessType?.toUpperCase() === 'TEXTILE' &&
         (lastDaybook?.isMillIssue || lastDaybook?.isOtherJobWork)
      ) {
         dispatch(getGrayPurchasePendingIssue());
      }

      return () => {};
   }, [businessTypes?.businessType, dispatch, lastDaybook?.isMillIssue, lastDaybook?.isOtherJobWork]);

   useEffect(() => {
      if (
         businessTypes?.businessType?.toUpperCase() === 'TEXTILE'
         // lastDaybook?.isMillReceive &&
         // lastDaybook?.issuedaybookid !== null
      ) {
         dispatch(getPendingReceiveInventories());
      }
      return () => {};
   }, [businessTypes?.businessType, dispatch, lastDaybook?.isMillReceive, lastDaybook?.issuedaybookid]);

   const wareshow = itemData?.some((item) =>
      lineItems?.some((lineItem) => lineItem.itemId === item.id && item.itemdetailtype !== 1),
   );

   return (
      <Box>
         <Button onClick={() => addLineItem()} colorScheme="blue" mb={3} _focus={{}}>
            Add Item
         </Button>
         <Box overflowX="auto">
            <TableContainer maxH="100%" border="1px" borderColor="gray.200" borderRadius={5}>
               <Table variant="simple" size="sm">
                  <Thead bg={headerbg}>
                     <Tr>
                        <Th color={textColor}>Index</Th>
                        <Th color={textColor}>Action</Th>
                        {(selectcompany?.setting?.warehouseWishStock === true && lineitemview === true) ||
                        (wareshow && type === 'purchase' && lineDetailview === true) ||
                        (wareshow && type === 'recive' && lineDetailview === true) ? (
                           <Th color={textColor} minW="210px">
                              Ware House
                           </Th>
                        ) : null}

                        {businessTypes?.businessType?.toUpperCase() === 'TEXTILE' &&
                        lastDaybook &&
                        (lastDaybook?.isMillIssue || lastDaybook?.isOtherJobWork) ? (
                           <Th color={textColor} minW="250px">
                              Purchase Documents
                           </Th>
                        ) : null}

                        {businessTypes?.businessType?.toUpperCase() === 'TEXTILE' &&
                        lastDaybook &&
                        lastDaybook?.isMillReceive &&
                        lastDaybook?.issuedaybookid !== null ? (
                           <Th color={textColor} minW="250px">
                              Issued Documents
                           </Th>
                        ) : null}

                        <Th color={textColor} minW="250px">
                           Item
                        </Th>
                        {lastDaybook && lastDaybook?.isAskTypeOfSupply ? (
                           <Th color={textColor} minW="210px">
                              Type of Supply
                           </Th>
                        ) : null}
                        {companySetting?.maxUOM > 1 ? (
                           <Th color={textColor} minW="250px">
                              Unit
                           </Th>
                        ) : null}

                        {headers.slice(0, companySetting?.maxUOM)?.map((header, index) => (
                           <Th key={index} color={textColor} minW="100px">
                              {header}
                           </Th>
                        ))}
                        {lastDaybook?.isAllowGstRate && lastDaybook?.applyGst ? (
                           <Th color={textColor} minW="120px">
                              GST Rate
                           </Th>
                        ) : null}
                        <Th color={textColor} minW="120px">
                           Rate
                        </Th>
                        {lastDaybook?.requireDiscountLineItem > 0 ? (
                           <Th color={textColor} minW="120px">
                              Amount
                           </Th>
                        ) : null}

                        {lastDaybook?.requireDiscountLineItem > 0 &&
                           new Array(lastDaybook?.requireDiscountLineItem).fill().map((item, index) => {
                              return (
                                 <React.Fragment key={index}>
                                    <Th color={textColor} minW="120px">
                                       Disc{index + 1} (%)
                                    </Th>
                                    <Th color={textColor} minW="120px" key={index}>
                                       Disc AMT {index + 1}
                                    </Th>
                                 </React.Fragment>
                              );
                           })}
                        <Th color={textColor} minW="100px">
                           Net Amt
                        </Th>

                        {company?.setting?.applyGST && lastDaybook?.applyGst ? (
                           <>
                              <Th color={textColor} minW="100px">
                                 GST %
                              </Th>
                              <Th color={textColor} minW="100px">
                                 GST Taxable
                              </Th>
                              <Th color={textColor} minW="100px">
                                 GST Amt
                              </Th>
                              <Th color={textColor} minW="100px">
                                 Amt + GST
                              </Th>
                           </>
                        ) : null}

                        {lastDaybook?.isAllowNotes ? (
                           <Th color={textColor} minW="150px">
                              Notes
                           </Th>
                        ) : null}

                        {lastDaybook?.isAllowRemark ? (
                           <Th color={textColor} minW="150px">
                              Remark
                           </Th>
                        ) : null}
                     </Tr>
                  </Thead>
                  <Tbody>
                     {lineItems?.map((lineItem, rowIndex) => {
                        const selectedItem = itemData?.find((item) => item.id === lineItem?.itemId);
                        const rowHeaders = getColumnHeaders(activeRow, lineItems, itemData);
                        const unit = lineItem?.unit;
                        const unitList = uqcData
                           .filter((uqc) =>
                              [selectedItem?.uqcid1, selectedItem?.uqcid2, selectedItem?.uqcid3].includes(uqc.id),
                           )
                           .sort((a, b) => {
                              const order = [selectedItem?.uqcid1, selectedItem?.uqcid2, selectedItem?.uqcid3];
                              return order.indexOf(a.id) - order.indexOf(b.id);
                           });

                        const serialitem = selectedItem?.itemdetailtype !== 1;
                        const showWarehouset =
                           (type === 'purchase' && lineItem?.itemId && serialitem) ||
                           (type === 'recive' && lineItem?.itemId && serialitem);
                        const showWarehouse =
                           selectcompany?.setting?.warehouseWishStock === true && lineitemview === true
                              ? true
                              : showWarehouset
                                ? showWarehouset
                                : false;

                        const isQty = lineItem?.qty1 === 0 || lineItem?.qty2 === 0 || lineItem?.qty3 === 0;

                        const qty =
                           unit === selectedItem?.uqc1Data?.id
                              ? lineItem?.qty1
                              : unit === selectedItem?.uqc2Data?.id
                                ? lineItem?.qty2
                                : unit === selectedItem?.uqc3Data?.id
                                  ? lineItem?.qty3
                                  : lineItem?.qty1;

                        return (
                           <Tr key={rowIndex} bgColor={lineItem.isDeleted ? 'red.200' : ''}>
                              <Td textAlign="center" color={textColor}>
                                 {rowIndex + 1}
                              </Td>
                              <Td>
                                 <IconButton
                                    onClick={() => removeLineItem(rowIndex, lineItem?.id)}
                                    colorScheme="red"
                                    size="sm"
                                    icon={<FaTrash />}
                                    disabled={lineItems.length === 1 || lineItem.isDeleted}
                                 />
                              </Td>

                              {(selectcompany?.setting?.warehouseWishStock === true && lineitemview === true) ||
                              (wareshow && type === 'purchase' && lineDetailview === true) ||
                              (wareshow && type === 'recive' && lineDetailview === true) ? (
                                 <Td>
                                    {showWarehouse ? (
                                       renderDynamicDropdown(
                                          'warehouseId',
                                          'Ware House',
                                          warehouseList,
                                          {
                                             value: lineItem?.warehouseId,
                                             ref: (el) => {
                                                if (refs?.warehouseRef && refs?.warehouseRef.current)
                                                   refs.warehouseRef.current[rowIndex] = el;
                                             },
                                             onChange: (value) =>
                                                handleOnChange('lineItem', 'warehouseId', value, rowIndex),
                                             showCustomNoOptions: true,
                                             openfrom: 'wareHouse',
                                             disabled: lineItem?.isDeleted ? true : false,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (
                                                      businessTypes?.businessType?.toUpperCase() === 'TEXTILE' &&
                                                      lastDaybook &&
                                                      (lastDaybook?.isMillIssue || lastDaybook?.isOtherJobWork)
                                                   ) {
                                                      refs?.purchaseDocumentRef?.current[rowIndex]?.focus();
                                                   } else if (
                                                      businessTypes?.businessType?.toUpperCase() === 'TEXTILE' &&
                                                      lastDaybook &&
                                                      lastDaybook?.isMillReceive &&
                                                      lastDaybook?.issuedaybookid !== null
                                                   ) {
                                                      refs?.issueDocRefs?.current[rowIndex]?.focus();
                                                   } else {
                                                      refs?.itemRefs?.current[rowIndex]?.focus();
                                                   }
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Ware House',
                                       )
                                    ) : (
                                       // Show blank space to keep alignment
                                       <Box h="40px" />
                                    )}
                                 </Td>
                              ) : null}

                              {businessTypes?.businessType?.toUpperCase() === 'TEXTILE' &&
                              lastDaybook &&
                              (lastDaybook?.isMillIssue || lastDaybook?.isOtherJobWork) ? (
                                 <Td>
                                    {renderDynamicDropdown(
                                       'purchaseDocumentId',
                                       'Purchase Documents',
                                       purchase &&
                                          purchase?.map((x) => ({
                                             label: x.item_description,
                                             id: x.purchase_id,
                                          })),
                                       {
                                          value: lineItem?.purchaseDocumentId ?? 1,
                                          onChange: (value) => {
                                             handleOnChange('lineItem', 'purchaseDocumentId', value, rowIndex);
                                             setCurrentLineItemIdx && setCurrentLineItemIdx(rowIndex);
                                          },
                                          focusBorderColor: 'blue.500', // Set the border color when focused
                                          _focus: {
                                             boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)', // Optional, add a shadow effect when focused
                                          },
                                          ref: (el) => {
                                             if (refs?.purchaseDocumentRef && refs?.itemRefs.current)
                                                refs.purchaseDocumentRef.current[rowIndex] = el;
                                          },
                                          disabled: lineItem?.isDeleted ? true : false,
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Purchase Documents',
                                    )}
                                 </Td>
                              ) : null}

                              {businessTypes?.businessType?.toUpperCase() === 'TEXTILE' &&
                              lastDaybook &&
                              lastDaybook?.isMillReceive &&
                              lastDaybook?.issuedaybookid !== null ? (
                                 <Td>
                                    {renderDynamicDropdown(
                                       'issuedDocumentId',
                                       'Issued Documents',
                                       pendingReceive &&
                                          pendingReceive?.map((x) => ({
                                             label: x.item_description,
                                             id: x.item_id,
                                          })),
                                       {
                                          value: lineItem?.issuedDocumentId ?? 1,
                                          onChange: (value) => {
                                             handleOnChange('lineItem', 'issuedDocumentId', value, rowIndex);
                                             setCurrentLineItemIdx && setCurrentLineItemIdx(rowIndex);
                                          },
                                          focusBorderColor: 'blue.500', // Set the border color when focused
                                          _focus: {
                                             boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)', // Optional, add a shadow effect when focused
                                          },
                                          disabled: lineItem?.isDeleted ? true : false,
                                          ref: (el) => {
                                             if (refs?.issueDocRefs && refs?.issueDocRefs.current)
                                                refs.issueDocRefs.current[rowIndex] = el;
                                          },
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                if (lineItem?.issuedDocumentId) {
                                                   refs?.rateRefs?.current[rowIndex]?.focus();
                                                } else {
                                                   refs?.itemRefs?.current[rowIndex]?.focus();
                                                }
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Purchase Documents',
                                    )}
                                 </Td>
                              ) : null}

                              <Td>
                                 <Flex justifyContent="flex-start" alignItems="center" gap={2}>
                                    {renderDynamicDropdown(
                                       'itemId',
                                       'Item',
                                       itemData,
                                       {
                                          errorName: `lineItem[${rowIndex}].itemId`,
                                          value: lineItem?.itemId,
                                          onChange: async (value) => {
                                             await handleOnChange('lineItem', 'itemId', value, rowIndex);
                                             handleModalOpen(value, rowIndex);
                                             setCurrentLineItemIdx && setCurrentLineItemIdx(rowIndex);
                                             // if (lineItems.length > 1 && value) {
                                             //    const selectedItem = itemData?.find(
                                             //       (item) => item.id.toString() === value?.toString(),
                                             //    );
                                             //    if (!selectedItem) return;
                                             //    if (selectedItem.itemdetailtype === 1) {
                                             //       if (
                                             //          lastDaybook?.isAllowGstRate &&
                                             //          companySetting?.applyGST &&
                                             //          lastDaybook?.applyGst
                                             //       ) {
                                             //          refs.gstRateRefs?.current[rowIndex]?.focus();
                                             //       }
                                             //       if (refs.rateRefs?.current[rowIndex]) {
                                             //          refs?.rateRefs?.current[rowIndex]?.focus();
                                             //       }
                                             //    } else {
                                             //       console.log('lineitem item', value, selectedItem);
                                             //       refs?.qty1Refs?.current[rowIndex]?.focus();
                                             //    }
                                             // }
                                          },
                                          focusBorderColor: 'blue.500', // Set the border color when focused
                                          _focus: {
                                             boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)', // Optional, add a shadow effect when focused
                                          },
                                          ref: (el) => {
                                             if (refs?.itemRefs && refs?.itemRefs.current)
                                                refs.itemRefs.current[rowIndex] = el;
                                          },
                                          showCustomNoOptions: true,
                                          openfrom: 'item',
                                          nextRef: refs?.qty1Refs?.current[rowIndex],
                                          disabled: lineItem?.isDeleted,
                                          isClearable: false,

                                          // preRef: prerefs,
                                          onKeyDown: async (e) => {
                                             if (e.key === 'Enter') {
                                                e.preventDefault();
                                                // itemRefs?.current[0]?.focus();
                                                if (e.shiftKey) {
                                                   if (
                                                      (selectcompany?.setting?.warehouseWishStock === true &&
                                                         lineitemview === true) ||
                                                      (wareshow && type === 'purchase' && lineDetailview === true) ||
                                                      (wareshow && type === 'recive' && lineDetailview === true)
                                                   ) {
                                                      refs.warehouseRef.current[rowIndex]?.focus();
                                                   } else {
                                                      if (rowIndex === 0) {
                                                         prerefs?.current?.focus();
                                                      } else {
                                                         refs.rateRefs.current[rowIndex - 1]?.focus();
                                                      }
                                                   }
                                                } else {
                                                   // if (selectedItem?.itemdetailtype === 1) {
                                                   //    if (
                                                   //       lastDaybook?.isAllowGstRate &&
                                                   //       companySetting?.applyGST &&
                                                   //       lastDaybook?.applyGst
                                                   //    ) {
                                                   //       refs.gstRateRefs?.current[rowIndex]?.focus();
                                                   //    }
                                                   //    if (refs.rateRefs?.current[rowIndex]) {
                                                   //       refs?.rateRefs?.current[rowIndex]?.focus();
                                                   //    }
                                                   // } else if (!selectedItem && lineItems.length > 1) {
                                                   //    await removeLineItem(rowIndex, null);
                                                   //    if (
                                                   //       billTermData?.length > 0 &&
                                                   //       refs?.percentageRefs &&
                                                   //       refs?.percentageRefs?.current[0]
                                                   //    ) {
                                                   //       refs?.percentageRefs?.current[0]?.focus();
                                                   //    } else {
                                                   //       refs?.dueDaysRef?.current?.focus();
                                                   //    }
                                                   // } else {
                                                   //    refs?.qty1Refs?.current[rowIndex]?.focus();
                                                   // }
                                                   if (selectedItem?.itemdetailtype === 0) {
                                                      if (refs?.qty1Refs?.current[rowIndex]) {
                                                         refs?.qty1Refs?.current[rowIndex]?.focus();
                                                         return;
                                                      }
                                                   }
                                                   if (selectedItem?.itemdetailtype === 1) {
                                                      if (
                                                         lastDaybook?.isAllowGstRate &&
                                                         companySetting?.applyGST &&
                                                         lastDaybook?.applyGst
                                                      ) {
                                                         refs.gstRateRefs?.current[rowIndex]?.focus();
                                                         return;
                                                      }
                                                      if (refs.rateRefs?.current[rowIndex]) {
                                                         refs?.rateRefs?.current[rowIndex]?.focus();
                                                         return;
                                                      }
                                                   }
                                                   if (!selectedItem?.id && lineItems.length > 1) {
                                                      await removeLineItem(rowIndex, null);
                                                      if (
                                                         billTermData?.length > 0 &&
                                                         refs?.percentageRefs &&
                                                         refs?.percentageRefs?.current[0]
                                                      ) {
                                                         refs?.percentageRefs?.current[0]?.focus();
                                                         return;
                                                      }
                                                      if (refs?.dueDaysRef?.current) {
                                                         refs?.dueDaysRef?.current?.focus();
                                                         return;
                                                      }
                                                   }
                                                   if (refs?.qty1Refs?.current[rowIndex]) {
                                                      refs?.qty1Refs?.current[rowIndex]?.focus();
                                                      return;
                                                   }
                                                }
                                             }
                                             if (e.key === 'Tab') {
                                                e.preventDefault();
                                                if (e.shiftKey) {
                                                   if (rowIndex === 0) {
                                                      prerefs?.current?.focus();
                                                   } else {
                                                      refs.rateRefs.current[rowIndex - 1]?.focus();
                                                   }
                                                } else {
                                                   if (selectedItem?.itemdetailtype === 1) {
                                                      refs?.rateRefs?.current[rowIndex]?.focus();
                                                   } else {
                                                      refs?.qty1Refs?.current[rowIndex]?.focus();
                                                   }
                                                }
                                             }
                                          },
                                          handleStockModalOnClick: () => handleStockModalOnClick(rowIndex),
                                          rowIndex: rowIndex,
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Item',
                                    )}
                                    {lineItem?.itemId &&
                                    lineItem?.itemId > 0 &&
                                    (selectedItem?.itemdetailtype === 1 ||
                                       (lastDaybook &&
                                          lastDaybook.getLineDetail &&
                                          businessTypes?.businessType?.toUpperCase() === 'TEXTILE')) ? (
                                       <IconButton
                                          onClick={() => {
                                             handleStockModalOnClick(rowIndex);
                                             setCurrentLineItemIdx && setCurrentLineItemIdx(rowIndex);
                                          }}
                                          colorScheme="green"
                                          size="sm"
                                          icon={<FaPlus />}
                                          disabled={lineItem.isDeleted}
                                       />
                                    ) : null}
                                 </Flex>
                              </Td>

                              {lastDaybook && lastDaybook?.isAskTypeOfSupply ? (
                                 <Td>
                                    {renderDynamicDropdown(
                                       'typeOfSupply',
                                       'Type of Supply',
                                       SupplyTypes,
                                       {
                                          value: lineItem?.typeOfSupply ?? 1,
                                          onChange: (value) =>
                                             handleOnChange('lineItem', 'typeOfSupply', value, rowIndex),
                                          focusBorderColor: 'blue.500', // Set the border color when focused
                                          _focus: {
                                             boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)', // Optional, add a shadow effect when focused
                                          },
                                          disabled: lineItem?.isDeleted ? true : false,
                                       },
                                       errors,
                                       textColor,
                                       true,
                                       'Select Item',
                                    )}
                                 </Td>
                              ) : null}

                              {companySetting?.maxUOM > 1 ? (
                                 <Td>
                                    {renderDynamicDropdown(
                                       'unit',
                                       'Unit',
                                       unitList,
                                       {
                                          value: unit,
                                          onChange: (value) => handleOnChange('lineItem', 'unit', value, rowIndex),
                                          focusBorderColor: 'blue.500', // Set the border color when focused
                                          _focus: {
                                             boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)', // Optional, add a shadow effect when focused
                                          },
                                          disabled: lineItem?.isDeleted ? true : false,
                                       },
                                       errors,
                                       textColor,
                                       true,
                                       'Select Unit',
                                    )}
                                 </Td>
                              ) : null}

                              {companySetting?.maxUOM > 0 && companySetting?.maxUOM <= 3 ? (
                                 <Td>
                                    <FormControl>
                                       <InputField
                                          ref={(el) => {
                                             if (refs?.qty1Refs && refs?.qty1Refs.current) {
                                                refs.qty1Refs.current[rowIndex] = el;
                                             }
                                          }}
                                          name="qty1"
                                          errorName={`lineItem[${rowIndex}].qty1`}
                                          placeholder={
                                             selectedItem && selectedItem.uqc1Data
                                                ? selectedItem.uqc1Data.name
                                                : 'Qty 1'
                                          }
                                          value={lineItem?.qty1 || ''}
                                          onChange={(e) => handleOnChange('lineItem', 'qty1', e.target.value, rowIndex)}
                                          onFocus={() => handleFocus(rowIndex, 2, selectedItem?.uqc1Data?.name)}
                                          disabled={selectedItem?.itemdetailtype === 1 || lineItem?.isDeleted}
                                          size="sm"
                                          type="number"
                                          // textAlign="right"
                                          errors={errors}
                                          onKeyDown={(e) => {
                                             if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                e.preventDefault();
                                             }
                                             if (e.key === 'Enter') {
                                                e.preventDefault();
                                                console.log('key for keybord', e.key, e.shiftKey);
                                                if (
                                                   lastDaybook?.isAllowGstRate &&
                                                   companySetting?.applyGST &&
                                                   lastDaybook?.applyGst
                                                ) {
                                                   refs.gstRateRefs.current[rowIndex].focus();
                                                } else {
                                                   refs.rateRefs.current[rowIndex].focus();
                                                }
                                             }
                                             if (e.key === 'Tab') {
                                                e.preventDefault();
                                                console.log('key for keybord', e.key, e.shiftKey);
                                                if (e.shiftKey) {
                                                   if (refs?.itemRefs?.current[rowIndex]) {
                                                      refs.itemRefs.current[rowIndex].focus();
                                                   }
                                                } else {
                                                   if (
                                                      lastDaybook?.isAllowGstRate &&
                                                      companySetting?.applyGST &&
                                                      lastDaybook?.applyGst
                                                   ) {
                                                      refs.gstRateRefs.current[rowIndex].focus();
                                                   } else {
                                                      refs.rateRefs.current[rowIndex].focus();
                                                   }
                                                }
                                             }
                                          }}
                                          onWheel={(e) => e.target.blur()}
                                       />
                                    </FormControl>
                                 </Td>
                              ) : null}

                              {companySetting?.maxUOM >= 2 && companySetting?.maxUOM <= 3 ? (
                                 <Td>
                                    <FormControl>
                                       <InputField
                                          name="qty2"
                                          placeholder={
                                             selectedItem && selectedItem.uqc2Data
                                                ? selectedItem.uqc2Data.name
                                                : 'Qty 2'
                                          }
                                          value={lineItem?.qty2 || ''}
                                          onChange={(e) => handleOnChange('lineItem', 'qty2', e.target.value, rowIndex)}
                                          onFocus={() => handleFocus(rowIndex, 2, selectedItem?.uqc1Data?.name)}
                                          disabled={selectedItem?.itemdetailtype === 1 || lineItem?.isDeleted}
                                          size="sm"
                                          type="number"
                                          onKeyDown={(e) => {
                                             if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                e.preventDefault();
                                             }

                                             // if (e.key === 'Enter' || e.key === 'Tab') {
                                             //    e.preventDefault();
                                             //    if (refs?.percentageRefs?.current[rowIndex]) {
                                             //       refs.percentageRefs.current[rowIndex].focus();
                                             //    }
                                             // }
                                          }}
                                          onWheel={(e) => e.target.blur()}
                                       />
                                    </FormControl>
                                 </Td>
                              ) : null}

                              {companySetting?.maxUOM === 3 ? (
                                 <Td>
                                    <FormControl>
                                       <InputField
                                          name="qty3"
                                          placeholder={
                                             selectedItem && selectedItem.uqc3Data
                                                ? selectedItem.uqc3Data.name
                                                : 'Qty 3'
                                          }
                                          value={lineItem?.qty3 || ''}
                                          onChange={(e) => handleOnChange('lineItem', 'qty3', e.target.value, rowIndex)}
                                          onFocus={() => handleFocus(rowIndex, 2, selectedItem?.uqc1Data?.name)}
                                          disabled={selectedItem?.itemdetailtype === 1 || lineItem?.isDeleted}
                                          size="sm"
                                          type="number"
                                          onKeyDown={(e) => {
                                             if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                e.preventDefault();
                                             }

                                             // if (e.key === 'Enter' || e.key === 'Tab') {
                                             //    e.preventDefault();
                                             //    if (refs?.percentageRefs?.current[rowIndex]) {
                                             //       refs.percentageRefs.current[rowIndex].focus();
                                             //    }
                                             // }
                                          }}
                                          onWheel={(e) => e.target.blur()}
                                       />
                                    </FormControl>
                                 </Td>
                              ) : null}

                              {lastDaybook?.isAllowGstRate && companySetting?.applyGST && lastDaybook?.applyGst ? (
                                 <Td>
                                    <FormControl>
                                       <InputField
                                          ref={(el) => {
                                             if (refs?.gstRateRefs && refs?.gstRateRefs.current) {
                                                refs.gstRateRefs.current[rowIndex] = el;
                                             }
                                          }}
                                          name="gstWithRate"
                                          id={`gstWithRate-${rowIndex}`}
                                          errorName={`lineItem[${rowIndex}].gstWithRate`}
                                          value={lineItem?.gstWithRate || ''}
                                          onChange={(e) =>
                                             handleOnChange('lineItem', 'gstWithRate', e.target.value, rowIndex)
                                          }
                                          onKeyDown={(e) => {
                                             if (e.key === 'Enter') {
                                                e.preventDefault();
                                                // itemRefs?.current[0]?.focus();

                                                if (refs?.rateRefs?.current[rowIndex])
                                                   refs?.rateRefs?.current[rowIndex]?.focus();
                                             }
                                             if (e.key === 'Tab') {
                                                e.preventDefault();
                                                if (e.shiftKey) {
                                                   if (
                                                      refs?.qty1Refs?.current[rowIndex] &&
                                                      !refs?.qty1Refs?.current[rowIndex]?.disabled
                                                   ) {
                                                      refs?.qty1Refs?.current[rowIndex]?.focus();
                                                   } else {
                                                      refs.itemRefs.current[rowIndex]?.focus();
                                                   }
                                                } else {
                                                   if (selectedItem?.itemdetailtype === 1) {
                                                      refs?.rateRefs?.current[rowIndex]?.focus();
                                                   } else {
                                                      refs?.rateRefs?.current[rowIndex]?.focus();
                                                   }
                                                }
                                             }
                                          }}
                                          onFocus={() => handleFocus(rowIndex, rowHeaders.length + 2, 'GST Rate')}
                                          size="sm"
                                          type="number"
                                       />
                                    </FormControl>
                                 </Td>
                              ) : null}

                              <Td>
                                 <FormControl>
                                    <InputField
                                       ref={(el) => {
                                          if (refs?.rateRefs && refs?.rateRefs.current) {
                                             refs.rateRefs.current[rowIndex] = el;
                                          }
                                       }}
                                       name="itemRate"
                                       id={`itemRate-${rowIndex}`}
                                       errorName={`lineItem[${rowIndex}].itemRate`}
                                       value={lineItem?.itemRate || ''}
                                       onChange={(e) =>
                                          handleOnChange('lineItem', 'itemRate', e.target.value, rowIndex)
                                       }
                                       onFocus={() => handleFocus(rowIndex, rowHeaders.length + 2, 'Rate')}
                                       onKeyDown={async (e) => {
                                          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                             e.preventDefault();
                                          }

                                          if ((e.key === 'Enter' && !e.shiftKey) || (e.key === 'Tab' && !e.shiftKey)) {
                                             e.preventDefault();

                                             if (lineItems[rowIndex]?.itemId && lineItems[rowIndex]?.itemId > 0) {
                                                const amountRef = refs?.subamountRefs?.current[rowIndex];
                                                const gstTaxableRef = refs?.gstTaxableRefs?.current?.[rowIndex];
                                                const lineItemNotesRef = refs?.lineItemNotesRef?.current[rowIndex];
                                                const lineItemRemarkRef = refs?.lineItemRemarkRef?.current[rowIndex];
                                                const itemRef = refs.itemRefs.current[rowIndex + 1];
                                                const amountFocusById = document.getElementById(
                                                   `amount-${rowIndex}`,
                                                )?.disabled;

                                                // 👉 GST TAXABLE FILED FOCUS
                                                if (
                                                   !!gstTaxableRef &&
                                                   !gstTaxableRef?.disabled &&
                                                   gstTaxableRef.focus
                                                ) {
                                                   console.log('gstTaxableRef');
                                                   gstTaxableRef?.focus();
                                                   return;
                                                }

                                                // 👉 NOTES FIELD FOCUS
                                                if (lastDaybook?.isAllowNotes) {
                                                   if (!!lineItemNotesRef) {
                                                      console.log('lineItemNotesRef');
                                                      lineItemNotesRef?.focus();
                                                      return;
                                                   }
                                                }

                                                // 👉 REMARKS FIELD FOCUS
                                                if (lastDaybook?.isAllowRemark) {
                                                   if (!!lineItemRemarkRef) {
                                                      console.log('lineItemRemarkRef');
                                                      lineItemRemarkRef?.focus();
                                                      return;
                                                   }
                                                }

                                                // 👉 AMOUNT FILED FOCUS
                                                if (!!amountRef && !amountFocusById) {
                                                   console.log('subamountRefs');
                                                   amountRef?.focus();
                                                   return;
                                                }

                                                // 👉 ITEM ID FIELD FOCUS
                                                if (!itemRef) {
                                                   await addLineItem();
                                                   refs.itemRefs.current[rowIndex + 1]?.focus();
                                                   return;
                                                } else {
                                                   refs.itemRefs.current[rowIndex + 1]?.focus();
                                                   return;
                                                }
                                             } else {
                                                if (lineItems.length > 1) {
                                                   await removeLineItem(rowIndex, null);
                                                   if (
                                                      billTermData?.length > 0 &&
                                                      refs?.percentageRefs &&
                                                      refs?.percentageRefs?.current[0]
                                                   ) {
                                                      refs?.percentageRefs?.current[0]?.focus();
                                                   } else {
                                                      refs?.dueDaysRef?.current?.focus();
                                                   }
                                                }
                                                if (lineItems.length === 1) {
                                                   await addLineItem();
                                                   refs.itemRefs.current[rowIndex + 1]?.focus();
                                                }
                                             }
                                          }
                                       }}
                                       size="sm"
                                       type="number"
                                       errors={errors}
                                       onWheel={(e) => e.target.blur()}
                                       disabled={lineItem.isDeleted}
                                    />
                                 </FormControl>
                              </Td>
                              {lastDaybook?.requireDiscountLineItem > 0 ? (
                                 <Td>
                                    <FormControl>
                                       <InputField
                                          ref={(el) => {
                                             if (refs?.subamountRefs && refs?.subamountRefs.current) {
                                                refs.subamountRefs.current[rowIndex] = el;
                                             }
                                          }}
                                          id={`amount-${rowIndex}`}
                                          name="amount"
                                          value={lineItem?.amount}
                                          onChange={(e) =>
                                             handleOnChange('lineItem', 'amount', e.target.value, rowIndex)
                                          }
                                          onFocus={() => handleFocus(rowIndex, rowHeaders.length + 2, 'Amount')}
                                          size="sm"
                                          type="number"
                                          // disabled
                                          disabled={
                                             qty >= 1 &&
                                             lastDaybook?.allowEditLIAmount &&
                                             !companySetting?.applyGST &&
                                             !lastDaybook?.applyGst
                                                ? false
                                                : true
                                          }
                                       />
                                    </FormControl>
                                 </Td>
                              ) : null}

                              {lastDaybook?.requireDiscountLineItem > 0 &&
                                 new Array(lastDaybook?.requireDiscountLineItem).fill('').map((item, index) => {
                                    return (
                                       <React.Fragment key={index}>
                                          <Td>
                                             <FormControl>
                                                <Input
                                                   name={`addLess${index + 1}Percent`}
                                                   placeholder={`Disc ${index + 1} (%)`}
                                                   value={lineItem[`addLess${index + 1}Percent`] || ''}
                                                   onChange={(e) =>
                                                      handleOnChange(
                                                         `lineItem`,
                                                         `addLess${index + 1}Percent`,
                                                         e.target.value,
                                                         rowIndex,
                                                      )
                                                   }
                                                   // onFocus={() =>
                                                   //   handleFocus(
                                                   //     rowIndex,
                                                   //     2,
                                                   //     selectedItem?.uqc1Data?.name,
                                                   //   )
                                                   // }
                                                   size="sm"
                                                   type="number"
                                                   disabled={lineItem.isDeleted}
                                                />
                                             </FormControl>
                                          </Td>
                                          <Td isNumeric>
                                             <FormControl>
                                                <Input
                                                   name={`addLess${index + 1}Amount`}
                                                   placeholder={`Disc ${index + 1} (%)`}
                                                   value={formatAmount(lineItem[`addLess${index + 1}Amount`] || '')}
                                                   onChange={(e) =>
                                                      handleOnChange(
                                                         `lineItem`,
                                                         `addLess${index + 1}Amount`,
                                                         e.target.value,
                                                         rowIndex,
                                                      )
                                                   }
                                                   // onFocus={() =>
                                                   //   handleFocus(
                                                   //     rowIndex,
                                                   //     2,
                                                   //     selectedItem?.uqc1Data?.name,
                                                   //   )
                                                   // }
                                                   size="sm"
                                                   type="number"
                                                   disabled
                                                />
                                             </FormControl>
                                          </Td>
                                       </React.Fragment>
                                    );
                                 })}

                              <Td isNumeric>
                                 <FormControl>
                                    <Input
                                       name={`netAmount`}
                                       placeholder={`Net Amount`}
                                       value={formatAmount(lineItem?.netAmount || '')}
                                       onChange={(e) =>
                                          handleOnChange(`lineItem`, `netAmount`, e.target.value, rowIndex)
                                       }
                                       // onFocus={() =>
                                       //   handleFocus(
                                       //     rowIndex,
                                       //     2,
                                       //     selectedItem?.uqc1Data?.name,
                                       //   )
                                       // }
                                       size="sm"
                                       type="number"
                                       disabled
                                    />
                                 </FormControl>
                              </Td>

                              {company?.setting?.applyGST && lastDaybook?.applyGst ? (
                                 <>
                                    <Td>
                                       <FormControl>
                                          <Input
                                             name="gst"
                                             value={lineItem?.gst || 0}
                                             onChange={(e) =>
                                                handleOnChange('lineItem', 'gst', e.target.value, rowIndex)
                                             }
                                             onFocus={() => handleFocus(rowIndex, 3, 'GST Rate')}
                                             size="sm"
                                             type="number"
                                             placeholder="GST Rate"
                                             disabled
                                          />
                                       </FormControl>
                                    </Td>

                                    <Td>
                                       <FormControl>
                                          <InputField
                                             ref={(el) => {
                                                if (refs?.gstTaxableRefs && refs?.gstTaxableRefs.current) {
                                                   refs.gstTaxableRefs.current[rowIndex] = el;
                                                }
                                             }}
                                             id={`taxableAmount-${rowIndex}`}
                                             name="taxableAmount"
                                             value={lineItem?.taxableAmount || 0}
                                             onChange={(e) =>
                                                handleOnChange('lineItem', 'taxableAmount', e.target.value, rowIndex)
                                             }
                                             onKeyDown={async (e) => {
                                                e.preventDefault();
                                                if (
                                                   (e.key === 'Enter' && !e.shiftKey) ||
                                                   (e.key === 'Tab' && !e.shiftKey)
                                                ) {
                                                   if (lastDaybook?.isAllowNotes) {
                                                      if (refs?.lineItemNotesRef?.current[rowIndex]) {
                                                         refs.lineItemNotesRef.current[rowIndex].focus();
                                                      }
                                                   } else if (lastDaybook?.isAllowRemark) {
                                                      if (refs?.lineItemRemarkRef?.current[rowIndex]) {
                                                         refs.lineItemRemarkRef.current[rowIndex].focus();
                                                      }
                                                   }
                                                   if (lineItems[rowIndex]?.itemId && lineItems[rowIndex]?.itemId > 0) {
                                                      // if (lineItems.length > 1) {
                                                      //    await removeLineItem(rowIndex, null);
                                                      //    if (refs?.percentageRefs && refs?.percentageRefs?.current[0]) {
                                                      //       refs?.percentageRefs?.current[0]?.focus();
                                                      //    } else {
                                                      //       refs?.dueDaysRef?.current?.focus();
                                                      //    }
                                                      // }
                                                      if (lineItems.length === 1) {
                                                         await addLineItem();
                                                         refs.itemRefs.current[rowIndex + 1]?.focus();
                                                      }
                                                   } else {
                                                      if (lineItems.length > 1) {
                                                         await removeLineItem(rowIndex, null);
                                                         if (refs?.percentageRefs && refs?.percentageRefs?.current[0]) {
                                                            refs?.percentageRefs?.current[0]?.focus();
                                                         } else {
                                                            refs?.dueDaysRef?.current?.focus();
                                                         }
                                                      }
                                                   }
                                                } else {
                                                   if (e.key === 'Tab' && e.shiftKey) {
                                                      if (
                                                         refs?.subamountRefs?.current[rowIndex] &&
                                                         !refs?.subamountRefs?.current[rowIndex]?.disabled
                                                      ) {
                                                         refs?.subamountRefs?.current[rowIndex]?.focus();
                                                      } else {
                                                         refs?.rateRefs?.current[rowIndex]?.focus();
                                                      }
                                                   }
                                                }
                                             }}
                                             onFocus={() => handleFocus(rowIndex, 3, 'GST Rate')}
                                             size="sm"
                                             type="number"
                                             placeholder="Taxable Amount"
                                             disabled={
                                                qty >= 1 &&
                                                lastDaybook?.allowEditLIAmount &&
                                                companySetting?.applyGST &&
                                                lastDaybook?.applyGst
                                                   ? false
                                                   : true
                                             }
                                          />
                                       </FormControl>
                                    </Td>

                                    <Td>
                                       <FormControl>
                                          <Input
                                             name="netGst"
                                             value={lineItem?.netGst?.toFixed(2) || 0}
                                             onChange={(e) =>
                                                handleOnChange('lineItem', 'netGst', e.target.value, rowIndex)
                                             }
                                             onFocus={() => handleFocus(rowIndex, 3, 'Net GST')}
                                             size="sm"
                                             type="number"
                                             placeholder="Net GST"
                                             disabled
                                          />
                                       </FormControl>
                                    </Td>

                                    <Td>
                                       <FormControl>
                                          <Input
                                             name="gstAmount"
                                             value={lineItem?.gstAmount?.toFixed(2) || 0}
                                             onChange={(e) =>
                                                handleOnChange('lineItem', 'gstAmount', e.target.value, rowIndex)
                                             }
                                             onFocus={() => handleFocus(rowIndex, 3, 'AMT + GST')}
                                             size="sm"
                                             type="number"
                                             placeholder="AMT + GST"
                                             disabled
                                          />
                                       </FormControl>
                                    </Td>
                                 </>
                              ) : null}

                              {lastDaybook?.isAllowNotes ? (
                                 <Td>
                                    <FormControl>
                                       <Input
                                          ref={(el) => {
                                             if (refs?.lineItemNotesRef && refs?.lineItemNotesRef.current) {
                                                refs.lineItemNotesRef.current[rowIndex] = el;
                                             }
                                          }}
                                          name="notes"
                                          value={lineItem?.notes || ''}
                                          onChange={(e) =>
                                             handleOnChange('lineItem', 'notes', e.target.value, rowIndex)
                                          }
                                          onFocus={() => handleFocus(rowIndex, 3, 'Notes')}
                                          size="sm"
                                          type="text"
                                          placeholder="Notes"
                                          onKeyDown={async (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                if (lineItems[rowIndex]?.itemId && lineItems[rowIndex]?.itemId > 0) {
                                                   if (
                                                      lastDaybook.isAllowRemark &&
                                                      refs?.lineItemRemarkRef?.current[rowIndex]
                                                   ) {
                                                      refs.lineItemRemarkRef.current[rowIndex]?.focus();
                                                   } else {
                                                      if (!refs.itemRefs.current[rowIndex + 1]) {
                                                         await addLineItem();
                                                         refs.itemRefs.current[rowIndex + 1]?.focus();
                                                      } else {
                                                         refs.itemRefs.current[rowIndex + 1]?.focus();
                                                      }
                                                   }
                                                } else {
                                                   if (lineItems.length > 1) {
                                                      await removeLineItem(rowIndex, null);
                                                      if (refs?.percentageRefs && refs?.percentageRefs?.current[0]) {
                                                         refs?.percentageRefs?.current[0]?.focus();
                                                      } else {
                                                         refs?.dueDaysRef?.current?.focus();
                                                      }
                                                   }
                                                   if (lineItems.length === 1) {
                                                      await addLineItem();
                                                      refs.itemRefs.current[rowIndex + 1]?.focus();
                                                   }
                                                }
                                             }
                                          }}
                                          disabled={lineItem.isDeleted}
                                       />
                                    </FormControl>
                                 </Td>
                              ) : null}

                              {lastDaybook?.isAllowRemark ? (
                                 <Td>
                                    <FormControl>
                                       <Input
                                          ref={(el) => {
                                             if (refs?.lineItemRemarkRef && refs?.lineItemRemarkRef.current) {
                                                refs.lineItemRemarkRef.current[rowIndex] = el;
                                             }
                                          }}
                                          name="remarks"
                                          value={lineItem?.remarks || ''}
                                          onChange={(e) =>
                                             handleOnChange('lineItem', 'remarks', e.target.value, rowIndex)
                                          }
                                          onFocus={() => handleFocus(rowIndex, 3, 'Remarks')}
                                          size="sm"
                                          type="text"
                                          placeholder="Remarks"
                                          onKeyDown={async (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                if (lineItems[rowIndex]?.itemId && lineItems[rowIndex]?.itemId > 0) {
                                                   if (!refs.itemRefs.current[rowIndex + 1]) {
                                                      await addLineItem();
                                                      refs.itemRefs.current[rowIndex + 1]?.focus();
                                                   } else {
                                                      refs.itemRefs.current[rowIndex + 1]?.focus();
                                                   }
                                                } else {
                                                   if (lineItems.length > 1) {
                                                      await removeLineItem(rowIndex, null);
                                                      if (refs?.percentageRefs && refs?.percentageRefs?.current[0]) {
                                                         refs?.percentageRefs?.current[0]?.focus();
                                                      } else {
                                                         refs?.dueDaysRef?.current?.focus();
                                                      }
                                                   }
                                                   if (lineItems.length === 1) {
                                                      await addLineItem();
                                                      refs.itemRefs.current[rowIndex + 1]?.focus();
                                                   }
                                                }
                                             }
                                          }}
                                          disabled={lineItem.isDeleted}
                                       />
                                    </FormControl>
                                 </Td>
                              ) : null}
                           </Tr>
                        );
                     })}
                  </Tbody>
                  <Tfoot>
                     <Tr>
                        <Th color={textColor}></Th>
                        <Th color={textColor}>Action</Th>
                        <Th color={textColor} colSpan={lastDaybook && lastDaybook?.isAskTypeOfSupply ? 2 : 1}>
                           Total
                        </Th>

                        {businessTypes?.businessType?.toUpperCase() === 'TEXTILE' &&
                        lastDaybook &&
                        (lastDaybook?.isMillIssue || lastDaybook?.isOtherJobWork) ? (
                           <Th colSpan={1}></Th>
                        ) : null}

                        {businessTypes?.businessType?.toUpperCase() === 'TEXTILE' &&
                        lastDaybook &&
                        lastDaybook?.isMillReceive &&
                        lastDaybook?.issuedaybookid !== null ? (
                           <Th colSpan={1}></Th>
                        ) : null}

                        {(selectcompany?.setting?.warehouseWishStock === true && lineitemview === true) ||
                        (wareshow && type === 'purchase' && lineDetailview === true) ||
                        (wareshow && type === 'recive' && lineDetailview === true) ? (
                           <Th></Th>
                        ) : null}
                        {companySetting?.maxUOM > 1 ? <Th></Th> : null}
                        {companySetting?.maxUOM > 0 && companySetting?.maxUOM <= 3 ? (
                           <Th color={textColor}>{totals?.qty1}</Th>
                        ) : null}
                        {companySetting?.maxUOM > 1 && companySetting?.maxUOM <= 3 ? (
                           <Th color={textColor}>{totals?.qty2}</Th>
                        ) : null}
                        {companySetting?.maxUOM > 2 && companySetting?.maxUOM <= 3 ? (
                           <Th color={textColor}>{totals?.qty3}</Th>
                        ) : null}
                        {lastDaybook?.isAllowGstRate && lastDaybook?.applyGst ? <Th></Th> : null}
                        <Th></Th>
                        {/* <Th isNumeric>-</Th> */}
                        {lastDaybook?.requireDiscountLineItem > 0 ? (
                           <Th color={textColor}>{totals?.basicAmount?.toFixed(2)}</Th>
                        ) : null}
                        {lastDaybook?.requireDiscountLineItem > 0 &&
                           new Array(lastDaybook?.requireDiscountLineItem).fill().map((item, index) => {
                              return (
                                 <React.Fragment key={index}>
                                    <Th></Th>
                                    <Th color={textColor}>{totals[`discount${index + 1}`]}</Th>
                                 </React.Fragment>
                              );
                           })}
                        <Th color={textColor}>{formatAmount(totals?.netAmount)}</Th>
                        {company?.setting?.applyGST && lastDaybook?.applyGst ? (
                           <>
                              <Th></Th>
                              <Th color={textColor}>{formatAmount(totals?.taxableAmount)}</Th>
                              <Th color={textColor}>{formatAmount(totals.netGstAmount)}</Th>
                              <Th></Th>
                           </>
                        ) : null}
                        {lastDaybook?.isAllowNotes ? <Th></Th> : null}
                        {lastDaybook?.isAllowRemark ? <Th></Th> : null}
                     </Tr>
                  </Tfoot>
               </Table>
            </TableContainer>
         </Box>
      </Box>
   );
};

export default LineItem;
